import CalendarIcon from '../icons/Calendar';
import style from './DateInputs.module.css';

interface DateInputsProps {
  value: {
    startDate: string;
    endDate: string;
  };
}

const DateInputs = ({ value }: DateInputsProps) => {
  return (
    <div className={style.inputsContainer}>
      <div className={style.inputContainer}>
        <label className={style.fieldLabel}>Початок</label>
        <div className={style.field}>
          <input
            type="text"
            value={value.startDate}
            placeholder="дд.мм.рррр"
            readOnly
          />
          <div className={style.calendarIcon}>
            <CalendarIcon />
          </div>
        </div>
      </div>
      <div className={style.inputContainer}>
        <label className={style.fieldLabel}>Кінець</label>
        <div className={style.field}>
          <input
            type="text"
            value={value.endDate}
            placeholder="дд.мм.рррр"
            readOnly
          />
          <div className={style.calendarIcon}>
            <CalendarIcon />
          </div>
        </div>
      </div>
    </div>
  );
};

export default DateInputs;
